import { IconProps } from ".";
import Icon from "./assets/doc_24_check.svg";
import { BaseIcon } from "./BaseIcon";

export function Icon24DocCheck(props: IconProps) {
  return <BaseIcon icon={<Icon />} {...props} />;
}
